<template>
  <footer>
    <div class="footer clearfix mb-0 text-muted">
      <div class="float-start">
        <p>2024 &copy; Fruits</p>
      </div>
      <div class="float-end">
        <p>
          Crafted with <span class="text-danger"><i class="bi bi-heart-fill icon-mid"></i></span> by
          <a href="#">Jessie</a>
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'FooterView',
};
</script>
